import React from "react";

import { Skeleton } from "@mui/material";

import { ListItemText, ListItem } from "./styled";

interface CustomerPortalListItemProps {
  title?: React.ReactNode | string;
  isLoadingTitle?: boolean;
  subtitle?: React.ReactNode | string;
  isLoadingSubtitle?: boolean;
  children?: React.ReactNode;
  capitalizeSubtitle?: boolean;
}

export const CustomerPortalListItem = (props: CustomerPortalListItemProps) => {
  const {
    title,
    subtitle,
    children,
    isLoadingSubtitle,
    isLoadingTitle,
    capitalizeSubtitle,
    ...rest
  } = props;

  const renderLoadingTitle = () => {
    if (isLoadingTitle) return <Skeleton variant="text" sx={{ fontSize: "14px" }} />;

    return title;
  };

  const renderLoadingSubtitle = () => {
    if (isLoadingSubtitle) return <Skeleton variant="text" sx={{ fontSize: "16px" }} />;

    return subtitle;
  };

  return (
    <ListItem dense disablePadding {...rest}>
      <ListItemText
        primary={renderLoadingTitle()}
        secondary={renderLoadingSubtitle()}
        primaryTypographyProps={{
          fontSize: "14px",
          fontWeight: 600,
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
        secondaryTypographyProps={{
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "24px",
          letterSpacing: "0.5px",
          textTransform: capitalizeSubtitle ? "capitalize" : undefined,
        }}
      />
      {children}
    </ListItem>
  );
};
